var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97619 11.3036H8.92857V2.00303C8.92857 1.38687 8.42867 0.886963 7.8125 0.886963H4.09226C3.4761 0.886963 2.97619 1.38687 2.97619 2.00303V11.3036ZM4.46429 2.37506H7.44048V3.11911H4.46429V2.37506ZM11.9048 4.23518V10.1876C11.9048 10.8037 11.4049 11.3036 10.7887 11.3036H9.67262V3.11911H10.7887C11.4049 3.11911 11.9048 3.61901 11.9048 4.23518ZM2.23214 11.3036H1.11607C0.499907 11.3036 0 10.8037 0 10.1876V4.23518C0 3.61901 0.499907 3.11911 1.11607 3.11911H2.23214V11.3036Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9048,
    height: 11.9048,
    fill: "white",
    transform: "translate(0 0.142822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.7a4920bde2529463b6bd427cef4d237e.svg";
export { ForwardRef as ReactComponent };